import React from 'react';
import { CardMediaBox } from '../../CardComponents/card-media-box/component.js';

// To keep things DRY, splitting this off to a component

var MediaBox = function MediaBox(_ref) {
  var cardProps = _ref.cardProps,
    cardEffects = _ref.cardEffects;
  var mediaAspectRatio = cardProps.mediaAspectRatio,
    mediaBackground = cardProps.mediaBackground,
    mediaDataAttributes = cardProps.mediaDataAttributes,
    mediaContent = cardProps.mediaContent,
    mediaUrl = cardProps.mediaUrl,
    mediaSize = cardProps.mediaSize,
    mediaPosition = cardProps.mediaPosition,
    type = cardProps.type;
  var hasLabel = cardEffects.hasLabel;
  return /*#__PURE__*/React.createElement(CardMediaBox, {
    "data-component-type": "presentation-card-media-box",
    chakra: 'on' // TODO remove with legacy card removal
    ,

    mediaAspectRatio: mediaAspectRatio,
    mediaBackground: mediaBackground,
    mediaDataAttributes: mediaDataAttributes,
    mediaContent: mediaContent,
    mediaUrl: mediaUrl,
    mediaSize: type === 'narrow' ? 'full' : mediaSize,
    mediaPosition: mediaPosition,
    hasLabel: hasLabel,
    type: type
  });
};
MediaBox.displayName = "MediaBox";
export { MediaBox };